import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Observable, of} from 'rxjs';
import {catchError, switchMap, tap} from 'rxjs/operators';
import {cache} from '../../../utils';
import {AppStateService} from '../../shared/app-state.service';
import {NavigationService} from '../../shared/navigation.service';
import {ProfileApiService} from '../profile-api.service';

@Component({
  selector: 'talent-profile-page',
  templateUrl: './talent-profile-page.component.html',
  styleUrls: ['./talent-profile-page.component.scss']
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class TalentProfilePageComponent implements OnInit {

  profile$: Observable<Talent.Profile>;

  constructor(private route: ActivatedRoute,
              private Navigation: NavigationService,
              private AppState: AppStateService,
              private Api: ProfileApiService) {
  }

  ngOnInit() {
    this.AppState.loading$.next(true);
    this.route.paramMap
      .pipe(
        switchMap(params => {
          if (params.has('submittalId')) {
            return this.Api.getSubmittalProfile(params.get('submittalId'));
          } else {
            return this.Api.getTalentProfile(params.get('talentId'));
          }
        }),
        tap(() => this.AppState.loading$.next(false)),
        catchError((err): never => { throw err; }),
        cache()
      ).subscribe(
        value => this.profile$ = of(value),
        err => {
          this.Navigation.handleError(err);
          throw err;
        }
      );
  }
}
